var map = {
	"./Imtihaan_1445H_badge_1.png": [
		6593,
		593
	],
	"./Imtihaan_1445H_badge_10.png": [
		9538,
		538
	],
	"./Imtihaan_1445H_badge_2.png": [
		8247,
		247
	],
	"./Imtihaan_1445H_badge_3.png": [
		7550,
		550
	],
	"./Imtihaan_1445H_badge_4.png": [
		1554,
		554
	],
	"./Imtihaan_1445H_badge_5.png": [
		8853,
		853
	],
	"./Imtihaan_1445H_badge_6.png": [
		5289,
		289
	],
	"./Imtihaan_1445H_badge_7.png": [
		5220,
		220
	],
	"./Imtihaan_1445H_badge_8.png": [
		7215,
		215
	],
	"./Imtihaan_1445H_badge_9.png": [
		7463,
		463
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5213;
module.exports = webpackAsyncContext;